export enum tab {
	home = 'home',
	files = 'files',
}

export function getTabPath(projectId: string, tabKey: tab | string) {
	return `/projects/${projectId}/${tabKey}`;
}
